export const isMultipleBlockSelected = (sel) => {
  // Process Selection in Multiple Richtext Instances
  if (!(sel && sel.rangeCount > 0)) {
    // If no selection is made then its not a multiple rt instance
    return false;
  }
  var range = sel.getRangeAt(0);

  if (typeof range.commonAncestorContainer === "string") {
    return false;
  }

  if (
    typeof range.commonAncestorContainer.getElementsByTagName === "function"
  ) {
    var blocks = range.commonAncestorContainer?.querySelectorAll(
      `[data-grigora-block="true"]`,
    );

    if (blocks && blocks.length > 1) {
      return true;
    }
    return false;
  }

  // var allWithinRangeParent = [];
  // try {
  //   var allWithinRangeParent =
  //     range?.commonAncestorContainer.getElementsByTagName("*");
  // } catch {}
  // if (allWithinRangeParent) {
  //   var allSelected = [];
  //   for (var i = 0, el; (el = allWithinRangeParent[i]); i++) {
  //     if (sel.containsNode(el, true)) {
  //       if (el.classList.contains("grigora-richtext-input__field")) {
  //         allSelected.push(el);
  //       }
  //     }
  //   }
  //   if (allSelected && allSelected.length > 1) {
  //     // Is Multiple Richtext Instances
  //     return true;
  //   }
  // }
  return false;
};
